// extracted by mini-css-extract-plugin
export default {"basic":"SortArrowIcon_basic__+oHrn","rotate":"SortArrowIcon_rotate__1AANq"};